<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Contact Information</h2>
    <button id="add_btn" (click)="openEditContactDialog(null)" mat-mini-fab *ngIf="editModeSet && !isAmbassador && !isRegionalManager">
      <mat-icon aria-label="Add Contact">add</mat-icon>
    </button>
  </div>
  <div class="section__body">
    <table *ngIf="business.contacts.length >0; else placeholder" class="data-block">
      <thead>
      <tr>
        <th class="data-block__label">Title/Dept</th>
        <th class="data-block__label">Name</th>
        <th class="data-block__label">Phone</th>
        <th class="data-block__label">Email</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let contact of business.contacts; let i = index" [ngTemplateOutlet]="tableRow" [ngTemplateOutletContext]="{contact: contact, i: i}">

      </ng-container>

      </tbody>
    </table>
  </div>
</div>

<ng-template #tableRow let-contact="contact" let-i="i">
  <tr class="data-block__item" [class.not-ok]="!contact.okToPublish" *ngIf="contact.okToPublish || (editModeSet && !isAmbassador)">
    <td class="data-block__value" [class.data-block__value__override]="editModeSet && !isAmbassador">
      <ng-container [ngTemplateOutlet]="contact.titleDept ? title : naTitle" [ngTemplateOutletContext]="{contact: contact, i: i}"></ng-container>
    </td>
    <td class="data-block__value">
      <ng-container *ngIf="contact.contactName; else na">{{ contact.contactName }}</ng-container>
    </td>
    <td class="data-block__value">
      <ng-container *ngIf="contact.phone; else na">{{ contact.phone | phone }}</ng-container>
    </td>
    <td class="data-block__value">
      <a *ngIf="contact.email; else na" href="mailto:{{contact.email}}">{{contact.email}}</a>
    </td>
  </tr>
</ng-template>

<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no contacts currently listed for this business.</div>
  </div>
</ng-template>

<ng-template #noneReportedPlaceholder>
  <span class="na">None reported</span>
</ng-template>

<ng-template #unknownPlaceholder>
  <span class="na">Unknown</span>
</ng-template>

<ng-template #na>
  <span class="na">N/A</span>
</ng-template>

<ng-template #naTitle let-i="i">
  <span class="na">
    N/A
    <mat-icon (click)="openEditContactDialog(i)"  *ngIf="editModeSet && !isAmbassador && !isRegionalManager" class="edit-icon" mat-tooltip="Edit Contact" aria-label="Button that opens popover that allows you to edit contacts">edit</mat-icon>
    <mat-icon (click)="deleteContact(i)"  *ngIf="editModeSet && !isAmbassador && !isRegionalManager" class="delete-icon" mat-tooltip="Delete Contact" aria-label="Button deletes row">delete_outline</mat-icon>
  </span>
</ng-template>

<ng-template #title let-contact="contact" let-i="i">
  {{ contact.titleDept }}
  <span class="icons-container">
    <mat-icon (click)="openEditContactDialog(i)"  *ngIf="editModeSet && !isAmbassador && !isRegionalManager" class="edit-icon" mat-tooltip="Edit Contacts" aria-label="Button that opens popover that allows you to edit contacts">edit</mat-icon>
    <mat-icon (click)="deleteContact(i)"  *ngIf="editModeSet && !isAmbassador && !isRegionalManager" class="delete-icon" mat-tooltip="Delete Contact" aria-label="Button deletes row">delete_outline</mat-icon>
  </span>
</ng-template>
